import { IContainerType } from "@tedivo/tedivo-textures-services-pure";

export function abbreviateContainerType(
  type: IContainerType | `${IContainerType}${number}${number}`,
): string {
  return type
    .replace("general", "GE")
    .replace("tank", "TK")
    .replace("flat", "FL")
    .replace("reefer", "RE")
    .replace("openTop", "OT")
    .replace("platform", "PL");
}
